/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getInvoiceAccountAsync } from './DataActionExtension.g';
import { IGetCheckoutValidationResponse } from './DataServiceEntities.g';

export class GetInvoiceAccountInput implements Msdyn365.IActionInput {
    public getCacheKey = () => 'GetInvoiceAccount';
    public getCacheObjectType = () => 'GetInvoiceAccountResponse';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

export interface IGetInvoiceAccountModelData {
    Blocked: boolean;
    BlockedType: number;
    InvoiceAccount: string;
}

const createInput = (): Msdyn365.IActionInput => {
    return new GetInvoiceAccountInput();
};

async function action(input: GetInvoiceAccountInput, ctx: Msdyn365.IActionContext): Promise<IGetCheckoutValidationResponse> {
    const response = await getInvoiceAccountAsync({ callerContext: ctx });

    return response;
}

export default Msdyn365.createObservableDataAction<IGetCheckoutValidationResponse>({
    action: <Msdyn365.IAction<IGetCheckoutValidationResponse>>action,
    id: 'invoiceAccountInfo',
    input: createInput
});
